import { IconUser } from '@tabler/icons-react';
import { useProfileContext } from '../../context/profileContext';

export function ProfilePage() {
  const { profile } = useProfileContext();

  return (
    <div className="profilePage">
      <div className="profile">
        <div className="profileIcon">
          <IconUser />
        </div>
        <div>
          <div className="profileName">Name</div>
          <div className="profileName">{profile.full_name}</div>
        </div>
      </div>
      <div className="profileField">
        <div className="profileFieldValue">Email</div>
        <div className="profileFieldValue">{profile.email}</div>
      </div>

      <div className="profileField">
        <div className="profileFieldValue">Auth provider</div>
        <div className="profileFieldValue">{profile.auth_provider}</div>
      </div>
      <div className="profileField">
        <div className="profileFieldValue">Available balance</div>
        <div className="profileFieldValue">{profile.available_balance} Sat on BSV</div>
      </div>

      <div className="profileField">
        <div className="profileFieldValue">Total balance</div>
        <div className="profileFieldValue">{profile.total_balance} Sat on BSV</div>
      </div>

      <div className="profileField">
        <div className="profileFieldValue">Status</div>
        <div className="profileFieldValue">{profile.status}</div>
      </div>
    </div>
  );
}
